export default {
  "nav": {
    "telecom": "Telecomunicaciones",
    "telecomInfrastructures": "Infraestructuras",
    "telecomFibre": "Fibra Óptica",
    "telecomMaintenance": "Mantenimiento",
    "genieCivilBTP": "Ingeniería Civil & Construcción",
    "home": "Inicio",
    "solutions": "Soluciones",
    "projets": "Proyectos",
    "aPropos": "Acerca de",
    "contact": "Contacto",
    "getQuote": "Solicitar Presupuesto"
  },
  "footer": {
    "telecomList": {
      "towers": "Torres y Pilónes",
      "fibre": "Fibra Óptica",
      "maintenance": "Mantenimiento NOC"
    },
    "tagline": "Líder en infraestructuras de telecomunicaciones y soluciones energéticas desde 2006. Conectamos comunidades e impulsamos el desarrollo sostenible.",
    "subscribe": "Suscribirse",
    "subscribePlaceholder": "Tu email",
    "services": "Servicios",
    "servicesList": {
      "microgrids": "Microrredes",
      "solarPumping": "Bombeo Solar",
      "storage": "Almacenamiento",
      "evCharging": "Carga de VE",
      "constructionMetal": "Construcción Metálica y Obra Civil",
      "itNetworks": "Informática y Redes",
      "audit": "Auditoría y Consultoría",
      "telecom": "Telecomunicaciones",
      "transport": "Transporte y Logística",
      "expertise": "Experiencia Técnica"
    },
    "company": "Empresa",
    "companyList": {
      "about": "Acerca de",
      "projects": "Nuestros Proyectos",
      "products": "Productos",
      "contact": "Contacto"
    },
    "contact": "Contacto",
    "copyright": "© 2026 IS TELECOM. Todos los derechos reservados.",
    "terms": "Términos y Condiciones",
    "privacy": "Política de Privacidad",
    "ctaTitle1": "Infraestructuras",
    "ctaTitle2": "telecom & energéticas",
    "ctaTitle3": "para cada región",
    "ctaButton": "Solicitar Presupuesto"
  },
  "hero": {
    "badge": "{ ENERGÍA Y TELECOM }",
    "titleLine1": "Soluciones",
    "titleLine2": "energéticas & telecom",
    "titleLine3": "del futuro",
    "subtitle": "Desde 2006, IS TELECOM despliega infraestructuras de telecomunicaciones y soluciones energéticas en 6 países de África.",
    "cta": "Solicitar Presupuesto"
  },
  "overview": {
    "badge": "Acerca de IS TELECOM",
    "titleLine1": "Excelencia en",
    "titleLine2": "cada proyecto de infraestructura",
    "description": "Nuestro equipo multidisciplinario combina experiencia en telecomunicaciones y energía para ofrecer soluciones de infraestructura fiables. Desde torres de transmisión hasta microrredes solares, conectamos comunidades e impulsamos el desarrollo sostenible.",
    "learnMore": "Saber Más",
    "statYears": "Años de experiencia",
    "statCountries": "Países atendidos",
    "statProjects": "Proyectos realizados"
  },
  "features": {
    "badge": "Características",
    "title": "Tres especialidades, una misión: construir el África del futuro",
    "items": [
      {"title": "Infraestructuras Telecom"},
      {"title": "Ingeniería Civil & BTP"},
      {"title": "Soluciones Energéticas"}
    ]
  },
  "services": {
    "badge": "Nuestros Servicios",
    "title": "Soluciones adaptadas a sus necesidades",
    "description": "Desde la energía solar hasta las telecomunicaciones, pasando por la construcción y el transporte, nuestra experiencia multidisciplinaria cubre todos sus proyectos de infraestructura.",
    "list": [
      {"title": "Evaluación Solar", "tags": ["Solar", "Consultoría"]},
      {"title": "Instalación de Paneles", "tags": ["Solar", "Instalación"]},
      {"title": "Almacenamiento en Batería", "tags": ["Solar", "Almacenamiento"]},
      {"title": "Monitorización y Soporte", "tags": ["Solar", "Monitorización"]},
      {"title": "Construcción Metálica y Obra Civil", "tags": ["Obra Civil", "Construcción"]},
      {"title": "Informática y Redes", "tags": ["IT", "Redes"]},
      {"title": "Auditoría y Consultoría", "tags": ["Auditoría", "Consultoría"]},
      {"title": "Telecomunicaciones", "tags": ["Telecom", "Infraestructura"]},
      {"title": "Transporte y Logística", "tags": ["Logística", "Transporte"]}
    ]
  },
  "projects": {
    "badge": "Nuestros Proyectos",
    "title": "Nuestras realizaciones recientes",
    "viewDetails": "Ver Detalles",
    "list": [
      {
        "category": "Microrredes",
        "year": "2023",
        "title": "Aldea — Electrificación Rural",
        "description": "Un sistema solar a medida que reduce los costes energéticos y lleva energía limpia a su comunidad."
      },
      {
        "category": "Telecomunicaciones",
        "year": "2025",
        "title": "Operador — Red Nacional de Telecom",
        "description": "Despliegue de infraestructura de telecomunicaciones con energía solar para 200 sitios, garantizando conectividad fiable en zonas rurales y urbanas."
      },
      {
        "category": "Monitorización",
        "year": "2024",
        "title": "Smart — Monitorización Avanzada",
        "description": "Siga el rendimiento de su sistema con una instalación solar conectada que le ayuda a entender cada kilovatio producido."
      }
    ]
  },
  "partners": {
    "badge": "Nuestros Socios",
    "title": "Ellos confían en nosotros",
    "description": "Líderes mundiales en telecomunicaciones, energía y tecnología colaboran con IS TELECOM para desplegar soluciones sostenibles en toda África."
  },
  "process": {
    "badge": "Proceso",
    "title": "Del estudio a la puesta en servicio",
    "description": "Le acompañamos desde la auditoría inicial hasta la puesta en servicio completa, ya sea para infraestructura de telecomunicaciones o proyectos energéticos.",
    "stepPrefix": "Paso",
    "steps": [
      {"title": "Estudio e Ingeniería", "description": "Analizamos sus necesidades, estudiamos el terreno y diseñamos planes de ingeniería detallados para su proyecto de infraestructura."},
      {"title": "Construcción e Instalación", "description": "Nuestros equipos certificados realizan la ingeniería civil, montan las estructuras e instalan los equipos con precisión y seguridad."},
      {"title": "Pruebas y Puesta en Marcha", "description": "Probamos rigurosamente cada componente, validamos el rendimiento y aseguramos la puesta en servicio completa de su infraestructura."}
    ]
  },
  "testimonials": {
    "badge": "Testimonios de Clientes",
    "titleLine1": "Socios de confianza,",
    "titleLine2": "infraestructura fiable",
    "verifiedReviews": "reseñas verificadas",
    "items": [
      {
        "quote": "IS TELECOM desplegó más de 200 sitios para nuestra red en Senegal. Su equipo domina perfectamente los equipos Huawei y cumplió todos los plazos, incluso en las zonas más difíciles de acceso.",
        "name": "Ahmadou Diallo",
        "role": "Director de Red, MTN Senegal"
      },
      {
        "quote": "La calidad de su trabajo en nuestro backbone de fibra óptica es notable. Pruebas OTDR impecables, documentación completa y un equipo que conoce los estándares Ericsson al dedillo.",
        "name": "Amina Diallo",
        "role": "Gerente de Infraestructura, Orange CI"
      },
      {
        "quote": "Su soporte NOC 24/7 marca toda la diferencia. Cuando un sitio falla a las 3am, el equipo de IS TELECOM ya está en el sitio a las 5am. Un nivel de capacidad de respuesta que no se encuentra en ningún otro lugar.",
        "name": "Koffi Agbessi",
        "role": "Director Técnico, Moov Africa"
      },
      {
        "quote": "Les confiamos la modernización 4G de 150 sitios. Formación de equipos, instalación, optimización de radio: todo se entregó a tiempo con una calidad que supera nuestras expectativas.",
        "name": "Dra. Fatou Beye",
        "role": "CTO, Airtel Senegal"
      },
      {
        "quote": "IS TELECOM es nuestro socio de referencia para mástiles. Sus estructuras son robustas, cumplen con las normas sísmicas y la ingeniería civil es impecable. Verdaderamente un trabajo de calidad.",
        "name": "Moussa Coulibaly",
        "role": "Gerente de Despliegue, Vodacom"
      },
      {
        "quote": "Despliegue FTTH rápido y limpio. En 3 meses, cablearon toda nuestra área metropolitana. Su experiencia en GPON y gestión de proyectos es impresionante.",
        "name": "Sophie Lawson",
        "role": "CEO, Togocom"
      }
    ]
  },
  "faq": {
    "badge": "FAQ",
    "title": "Preguntas Frecuentes",
    "homeFaqs": [
      {"q": "01. ¿Qué servicios de telecomunicaciones ofrece IS TELECOM?", "a": "Desplegamos infraestructura de telecomunicaciones completa: torres y mástiles, redes de fibra óptica, mantenimiento de equipos de radio y soluciones de conectividad para zonas rurales y urbanas. Socios de Huawei, Ericsson y MTN, cubrimos toda la cadena de telecomunicaciones."},
      {"q": "02. ¿En qué países operan?", "a": "IS TELECOM está presente en 6 países africanos de África Occidental y Oriental: Benín, Togo, Malí, Zambia, Tanzania y Senegal. Tenemos oficinas en cada uno de estos países y desplegamos proyectos de telecomunicaciones y energía allí."},
      {"q": "03. ¿Qué tipos de torres de telecomunicaciones instalan?", "a": "Diseñamos e instalamos todo tipo de mástiles: autosoportados (hasta 120m), arriostrados, monopolos urbanos y mástiles tubulares. Cada instalación cumple con las normas internacionales ANSI/TIA-222."},
      {"q": "04. ¿Ofrecen contratos de mantenimiento de telecomunicaciones?", "a": "Absolutamente. Nuestros contratos de mantenimiento incluyen intervenciones preventivas programadas, soporte NOC 24/7, intervenciones correctivas en 4 horas (SLA garantizado) y gestión completa de repuestos."}
    ]
  },
  "contact": {
    "pageTitle": "Contáctenos",
    "pageSubtitle": "¿Listo para desplegar su infraestructura de telecomunicaciones o su proyecto energético? Nuestro equipo está aquí para ayudarle",
    "infoPhone": "Teléfono",
    "infoEmail": "Email",
    "infoAddress": "Dirección",
    "infoHours": "Horario",
    "hoursLine1": "Lunes - Viernes: 8:00 - 18:00",
    "hoursLine2": "Soporte NOC: 24/7",
    "formTitle": "Envíenos un Mensaje",
    "formSubtitle": "Complete el formulario a continuación y nuestro equipo le responderá en 24 horas.",
    "formSuccess": "¡Mensaje Enviado!",
    "formSuccessMsg": "Le responderemos lo antes posible.",
    "labelName": "Nombre Completo",
    "placeholderName": "Su nombre y apellido",
    "labelEmail": "Email",
    "placeholderEmail": "su@email.com",
    "labelPhone": "Teléfono",
    "placeholderPhone": "+229 XX XX XX XX",
    "labelSubject": "Asunto",
    "subjectOptions": {
      "info": "Información General",
      "tech": "Información Técnica",
      "partnership": "Asociación",
      "careers": "Carreras",
      "other": "Otro"
    },
    "labelMessage": "Mensaje",
    "placeholderMessage": "Describa su proyecto o preguntas...",
    "sending": "Enviando...",
    "send": "Enviar Mensaje",
    "quickResponse": "¿Necesita una respuesta rápida?",
    "freeQuote": "Presupuesto Gratuito:",
    "freeQuoteDesc": "Reciba una estimación en 48 horas hábiles para cualquier proyecto de infraestructura.",
    "techSupport": "Soporte Técnico:",
    "techSupportDesc": "Nuestro NOC está disponible 24/7 para clientes con contratos de mantenimiento.",
    "siteVisit": "Visita Presencial:",
    "siteVisitDesc": "Nos desplazamos gratuitamente para evaluar sus necesidades de infraestructura.",
    "faqTitle": "Preguntas Frecuentes",
    "contactFaqs": [
      {"q": "¿Cuánto tiempo lleva desplegar un sitio de telecomunicaciones?", "a": "Para un sitio estándar, el plazo es de 2 a 4 semanas después del estudio de ingeniería. Para proyectos de backbone de fibra o multisitio, el calendario se personaliza según el alcance del proyecto."},
      {"q": "¿Ofrecen servicios de mantenimiento de telecomunicaciones?", "a": "Sí, todos nuestros contratos incluyen mantenimiento preventivo programado y soporte NOC 24/7 con intervención garantizada en 4 horas. También ofrecemos contratos de mantenimiento extendidos."},
      {"q": "¿Cuánto tardan en enviar un presupuesto?", "a": "Le enviamos un presupuesto detallado en 48 horas hábiles tras recibir su solicitud. Para proyectos complejos, puede ser necesaria una visita técnica."},
      {"q": "¿Trabajan fuera de África?", "a": "Nuestra actividad está enfocada en 6 países africanos: Benín, Togo, Malí, Zambia, Tanzania y Senegal. Esta presencia orientada nos permite ofrecer experiencia local y una capacidad de respuesta óptima en cada uno de estos mercados."},
      {"q": "¿Qué certificaciones tienen?", "a": "Estamos certificados ISO 9001 e ISO 14001. Nuestros equipos están formados y certificados por Huawei, Ericsson y Nokia. Todas nuestras instalaciones cumplen con las normas ANSI/TIA-222."}
    ]
  },
  "devis": {
    "pageTitle": "Solicite su Presupuesto Personalizado",
    "pageSubtitle": "Describa su proyecto de infraestructura de telecomunicaciones o energía y reciba una estimación detallada en 48 horas, sin compromiso",
    "badge": "Presupuesto Gratuito",
    "advantages": [
      {"text": "Respuesta en 48h"},
      {"text": "Presupuesto gratuito y sin compromiso"},
      {"text": "Estudio personalizado por nuestros expertos"},
      {"text": "Operando en 6 países"}
    ],
    "step1Title": "Paso 1: Su Información",
    "step2Title": "Paso 2: Su Proyecto",
    "step3Title": "Paso 3: Resumen",
    "labelName": "Nombre Completo",
    "labelCompany": "Empresa / Organización",
    "placeholderCompany": "Nombre de su empresa",
    "labelEmail": "Email",
    "labelPhone": "Teléfono",
    "labelLocation": "Ubicación del Proyecto",
    "placeholderLocation": "Ciudad, País",
    "labelProjectType": "Tipo de Proyecto",
    "selectProject": "Seleccione el tipo de proyecto",
    "labelBudget": "Presupuesto Estimado",
    "selectBudget": "Seleccione un rango",
    "labelTimeline": "Plazo Deseado",
    "selectTimeline": "Seleccione un plazo",
    "labelPower": "Detalles Técnicos (opcional)",
    "placeholderPower": "Ej: mástil 80m, backbone 200km, 50 sitios telecom...",
    "labelDescription": "Descripción del Proyecto",
    "placeholderDescription": "Describa su proyecto de infraestructura, objetivos, limitaciones técnicas...",
    "continue": "Continuar",
    "back": "Volver",
    "send": "Enviar Solicitud",
    "sending": "Enviando...",
    "success": "¡Presupuesto Solicitado con Éxito!",
    "successMsg": "Nuestro equipo está analizando su proyecto y le responderá en 48 horas hábiles con una propuesta detallada.",
    "recapName": "Nombre:",
    "recapCompany": "Empresa:",
    "recapEmail": "Email:",
    "recapPhone": "Teléfono:",
    "recapProjectType": "Tipo de Proyecto:",
    "recapLocation": "Ubicación:",
    "recapBudget": "Presupuesto:",
    "recapTimeline": "Plazo:",
    "recapPower": "Detalles Técnicos:",
    "recapDescription": "Descripción:",
    "projectTypes": [
      {"value": "micro-reseau", "label": "Microrred Solar"},
      {"value": "pompage", "label": "Bombeo Solar"},
      {"value": "stockage", "label": "Almacenamiento de Energía"},
      {"value": "recharge-ve", "label": "Carga de VE"},
      {"value": "residentiel", "label": "Instalación Residencial"},
      {"value": "industriel", "label": "Instalación Industrial"},
      {"value": "btp", "label": "Construcción Metálica y Obra Civil"},
      {"value": "informatique", "label": "Informática (Redes, Servidores)"},
      {"value": "audit", "label": "Auditoría y Consultoría"},
      {"value": "telecom", "label": "Telecom (Torres, Fibra)"},
      {"value": "transport", "label": "Transporte y Logística"},
      {"value": "autre", "label": "Otro Proyecto"}
    ],
    "budgets": [
      {"value": "", "label": "Seleccione un rango"},
      {"value": "moins-5k", "label": "Menos de 5.000 €"},
      {"value": "5k-20k", "label": "5.000 € - 20.000 €"},
      {"value": "20k-100k", "label": "20.000 € - 100.000 €"},
      {"value": "100k-500k", "label": "100.000 € - 500.000 €"},
      {"value": "plus-500k", "label": "Más de 500.000 €"}
    ],
    "timelines": [
      {"value": "", "label": "Seleccione un plazo"},
      {"value": "urgent", "label": "Urgente (menos de 1 mes)"},
      {"value": "1-3", "label": "1 a 3 meses"},
      {"value": "3-6", "label": "3 a 6 meses"},
      {"value": "6-12", "label": "6 a 12 meses"},
      {"value": "plus-12", "label": "Más de 12 meses"}
    ],
    "afterTitle": "Qué Sucede Después de Su Solicitud",
    "afterBadge": "¿Y Después?",
    "afterSteps": [
      {"title": "Confirmación", "desc": "Recibirá un email de confirmación con el resumen de su solicitud en 1 hora."},
      {"title": "Análisis de Expertos", "desc": "Nuestro equipo técnico estudia su proyecto y evalúa la viabilidad técnica."},
      {"title": "Presupuesto Detallado", "desc": "Recibirá un presupuesto completo con especificaciones técnicas, plazos y precios en 48h."},
      {"title": "Discusión Personalizada", "desc": "Un jefe de proyecto le contacta para discutir el presupuesto y responder a sus preguntas."}
    ],
    "faqTitle": "Preguntas Sobre Presupuestos",
    "devisFaqs": [
      {"q": "¿El presupuesto es realmente gratuito?", "a": "Sí, absolutamente. El estudio de su proyecto y la elaboración del presupuesto son completamente gratuitos y sin compromiso por su parte."},
      {"q": "¿Cuánto tardaré en recibir mi presupuesto?", "a": "Nos comprometemos a enviarle un presupuesto detallado en 48 horas hábiles. Para proyectos complejos que requieran visita técnica, el plazo puede ser de 5 a 7 días."},
      {"q": "¿Qué incluye el presupuesto?", "a": "El presupuesto incluye: especificaciones técnicas detalladas, lista completa de equipos, calendario de instalación, condiciones de garantía y el precio total detallado."},
      {"q": "¿Puedo modificar mi proyecto después de recibir el presupuesto?", "a": "¡Por supuesto! El presupuesto es una base de discusión. Nuestros equipos están a su disposición para ajustar la solución a sus necesidades y limitaciones."}
    ]
  },
  "about": {
    "pageTitle": "Acerca de IS TELECOM",
    "pageSubtitle": "La historia de un pionero de las telecomunicaciones en África, al servicio de la conectividad desde 2006",
    "missionBadge": "Nuestra Misión",
    "missionTitle": "Conectar África a las redes del mañana",
    "missionDesc1": "IS TELECOM nació en 2006 con una visión ambiciosa: construir la infraestructura de telecomunicaciones que conecte a las poblaciones africanas con el resto del mundo. Desde Cotonú, hemos tejido una red de confianza con los mayores actores mundiales de las telecomunicaciones.",
    "missionDesc2": "Hoy, socios de Huawei, Ericsson, MTN, Orange y muchos otros, hemos desplegado más de 5.000 sitios de telecomunicaciones en 6 países africanos. Nuestra experiencia cubre toda la cadena: torres, fibra óptica, mantenimiento y energía solar para sitios aislados.",
    "statCountries": "Países Atendidos",
    "statProjects": "Proyectos Realizados",
    "statExperts": "Expertos Desplegados",
    "statCapacity": "Sitios Telecom Desplegados",
    "certifiedBadge": "Certificado ISO 9001",
    "certifiedSub": "Calidad Garantizada",
    "valuesBadge": "Nuestros Valores",
    "valuesTitle": "Lo que nos guía cada día",
    "values": [
      {"title": "Conectividad Universal", "desc": "Creemos que cada comunidad merece acceso fiable a las redes de telecomunicaciones, desde las metrópolis hasta los pueblos más aislados."},
      {"title": "Excelencia Técnica", "desc": "Todos nuestros sitios cumplen con las normas internacionales más estrictas. Nuestros equipos están formados y certificados por Huawei, Ericsson y Nokia."},
      {"title": "Alcance Internacional", "desc": "Presentes en 6 países de África Occidental y Oriental, adaptamos nuestras soluciones de conectividad a los contextos locales y necesidades específicas."},
      {"title": "Innovación Continua", "desc": "Invertimos en las tecnologías del mañana: 5G, IoT, edge computing y smart cities."},
      {"title": "Proximidad al Cliente", "desc": "Acompañamiento personalizado con soporte técnico NOC 24/7, en toda África."},
      {"title": "Impacto Social", "desc": "Cada sitio de telecomunicaciones que desplegamos crea empleos locales y abre el acceso a la educación, la salud y la economía digital."}
    ],
    "timelineBadge": "Nuestra Trayectoria",
    "timelineTitle": "19 años de liderazgo en telecomunicaciones",
    "timeline": [
      {"year": "2006", "title": "Creación de IS TELECOM", "desc": "Empresa fundada en Cotonú, Benín, con una misión clara: desplegar la infraestructura de telecomunicaciones que conectará África Occidental."},
      {"year": "2009", "title": "Alianza Huawei", "desc": "Firma del primer contrato de colaboración con Huawei Technologies para el despliegue de infraestructura de radio en África Occidental. Formación de nuestros primeros equipos certificados."},
      {"year": "2012", "title": "Alianza Ericsson", "desc": "IS TELECOM se convierte en socio certificado de Ericsson para el mantenimiento y despliegue de equipos RAN (Radio Access Network). Expansión a Togo y Malí."},
      {"year": "2015", "title": "Contrato Marco MTN", "desc": "Firma de un contrato marco plurianual con MTN para el despliegue y mantenimiento de más de 800 sitios de telecomunicaciones en nuestros 6 países de operación."},
      {"year": "2019", "title": "Despliegue 4G y Fibra", "desc": "Lanzamiento de los primeros despliegues 4G/LTE y redes backbone de fibra óptica. Más de 2.000 sitios de telecomunicaciones en gestión activa."},
      {"year": "2024", "title": "Líder Panafricano", "desc": "Más de 5.000 sitios de telecomunicaciones desplegados en 6 países africanos. Alianzas estratégicas con Orange, Airtel, Vodacom. Certificación ISO 9001 y precalificación 5G."}
    ],
    "certBadge": "Certificaciones",
    "certTitle": "Nuestras Certificaciones",
    "certDesc": "Estándares internacionales para garantizar la calidad y seguridad de nuestra infraestructura de telecomunicaciones",
    "certs": [
      {"label": "ISO 9001", "desc": "Calidad"},
      {"label": "Huawei Certified", "desc": "Socio Aprobado"},
      {"label": "Ericsson Certified", "desc": "RAN & Core"},
      {"label": "ISO 14001", "desc": "Medio Ambiente"}
    ]
  },
  "solutions": {
    "pageTitle": "Nuestras Soluciones y Servicios",
    "pageSubtitle": "Infraestructura de telecomunicaciones y sistemas energéticos a medida para satisfacer todas sus necesidades, desde torres de transmisión hasta proyectos solares industriales",
    "processBadge": "Nuestro Proceso",
    "processTitle": "Cómo Trabajamos",
    "processSteps": [
      {"title": "Auditoría y Consultoría", "desc": "Análisis de sus necesidades técnicas y estudio de viabilidad in situ, ya sea para telecomunicaciones o energía."},
      {"title": "Diseño", "desc": "Dimensionamiento personalizado con planes de ingeniería detallados para su infraestructura."},
      {"title": "Instalación", "desc": "Implementación por nuestros equipos certificados, cumpliendo con las normas internacionales."},
      {"title": "Monitorización y Mantenimiento", "desc": "Monitorización remota e intervenciones preventivas garantizadas 24/7."}
    ],
    "ctaTitle": "¿Necesita una solución a medida?",
    "ctaSubtitle": "Nuestros ingenieros estudian gratuitamente su proyecto de telecomunicaciones o energía y proponen una solución adaptada a sus necesidades y presupuesto.",
    "ctaButton": "Solicitar una Auditoría Gratuita",
    "keyFeatures": "Características Clave",
    "useCases": "Casos de Uso",
    "requestQuote": "Solicitar Presupuesto para Esta Solución",
    "solutions": [
      {
        "title": "Sistemas de Microrredes",
        "shortDesc": "Soluciones completas para electrificación rural y urbana con gestión inteligente.",
        "fullDesc": "Nuestros sistemas de microrredes están diseñados para proporcionar energía fiable y sostenible en zonas no conectadas a la red nacional. Cada solución integra paneles fotovoltaicos, baterías de almacenamiento, inversores inteligentes y un sistema de monitorización centralizado.",
        "features": ["Gestión automatizada de producción y consumo", "Monitorización en tiempo real mediante plataforma web y móvil", "Mantenimiento predictivo con alertas automáticas", "Fácil integración con fuentes de energía existentes", "Tarificación inteligente y gestión de abonados"],
        "useCases": ["Aldeas rurales en África", "Zonas periurbanas", "Islas aisladas", "Sitios industriales remotos"]
      },
      {
        "title": "Bombeo Solar",
        "shortDesc": "Sistemas de bombeo e irrigación solar para agricultura y suministro de agua.",
        "fullDesc": "Nuestras soluciones de bombeo solar transforman la luz solar en agua potable e irrigación. Adaptadas a contextos rurales y agrícolas, reducen los costes operativos y garantizan una disponibilidad constante de agua.",
        "features": ["Bombas sumergibles de alta eficiencia", "Sistemas de riego por goteo integrados", "Control automático de caudal y presión", "Compatible con perforaciones profundas y pozos", "Robustez adaptada a condiciones climáticas extremas"],
        "useCases": ["Explotaciones agrícolas", "Comunidades rurales", "Ganaderías", "Jardines botánicos"]
      },
      {
        "title": "Almacenamiento de Energía",
        "shortDesc": "Soluciones de almacenamiento residencial e industrial con baterías de litio de alto rendimiento.",
        "fullDesc": "El almacenamiento es el corazón de cualquier instalación solar autónoma. Ofrecemos soluciones de baterías de iones de litio de última generación, con capacidades desde residencial hasta industrial, combinadas con inversores híbridos inteligentes.",
        "features": ["Baterías de litio de alta densidad energética", "Inversores híbridos con conmutación automática", "Gestión inteligente del ciclo de carga/descarga", "Escalabilidad modular según necesidades", "Garantía extendida de hasta 15 años"],
        "useCases": ["Viviendas unifamiliares", "Hoteles y resorts", "Centros de salud", "Industrias"]
      },
      {
        "title": "Carga de Vehículos Eléctricos",
        "shortDesc": "Estaciones de carga solar para vehículos eléctricos, soluciones completas y sostenibles.",
        "fullDesc": "Instalamos estaciones de carga para vehículos eléctricos alimentadas 100% por energía solar. Desde cargadores residenciales hasta estaciones de carga rápida públicas, diseñamos soluciones adaptadas a cada necesidad.",
        "features": ["Estaciones de carga rápida (hasta 150 kW)", "Alimentación solar con almacenamiento intermedio", "Gestión de flujos y optimización tarifaria", "Monitorización del consumo y sesiones", "Compatibilidad con todos los estándares de carga"],
        "useCases": ["Aparcamientos de empresas", "Estaciones de servicio", "Centros comerciales", "Residencias colectivas"]
      },
      {
        "title": "Soluciones Residenciales",
        "shortDesc": "Sistemas solares para viviendas, hoteles y centros sanitarios.",
        "fullDesc": "Nuestras soluciones residenciales combinan rendimiento, estética y simplicidad. Cada instalación es a medida, dimensionada según el consumo del hogar y las limitaciones del sitio. Instalación llave en mano con mantenimiento incluido.",
        "features": ["Instalación llave en mano en 2 a 5 días", "Mantenimiento preventivo y correctivo incluido", "Garantía extendida en equipos y mano de obra", "Monitorización remota de la producción", "Autoconsumo y venta de excedentes"],
        "useCases": ["Viviendas unifamiliares", "Hoteles y casas de huéspedes", "Clínicas y farmacias", "Escuelas y centros de formación"]
      },
      {
        "title": "Soluciones Industriales",
        "shortDesc": "Sistemas de alta potencia para zonas rurales, explotaciones mineras e industrias.",
        "fullDesc": "Para las necesidades energéticas más exigentes, desplegamos sistemas industriales de alta potencia. Desde minas aisladas hasta zonas industriales, nuestras soluciones garantizan energía fiable 24/7 con un retorno de inversión optimizado.",
        "features": ["Capacidades de 100 kW a varios MW", "Robustez industrial certificada", "Soporte técnico 24/7 con línea directa dedicada", "Posible integración híbrida diésel/solar", "Supervisión centralizada multisitio"],
        "useCases": ["Minas y canteras", "Zonas industriales", "Fábricas de manufactura", "Puertos y aeropuertos"]
      },
      {
        "title": "Torres y Mástiles de Telecom",
        "shortDesc": "Instalación y mantenimiento de torres de telecomunicación, mástiles autosoportados y arriostrados.",
        "fullDesc": "IS TELECOM es un actor importante en el despliegue de infraestructura de telecomunicaciones en África. Diseñamos, fabricamos e instalamos torres de telecomunicación de todas las dimensiones: torres autosoportadas, mástiles arriostrados, monopolos y mástiles tubulares. Nuestros equipos operan en todo tipo de terrenos, desde centros urbanos densos hasta las zonas rurales más aisladas.",
        "features": ["Torres autosoportadas de hasta 120 metros", "Torres arriostradas para zonas de alto viento", "Monopolos urbanos compactos", "Cimentaciones e ingeniería civil incluidas", "Normas internacionales (ANSI/TIA-222)"],
        "useCases": ["Operadores móviles (MTN, Orange, Vodacom)", "Enlaces de microondas", "Radiodifusión y TV", "Energía (eólica, monitorización)"]
      },
      {
        "title": "Redes de Fibra Óptica",
        "shortDesc": "Despliegue de redes de fibra óptica y backbones de transmisión para operadores de telecomunicaciones.",
        "fullDesc": "Desplegamos redes de fibra óptica de extremo a extremo: estudios de ingeniería, tendido de cables, empalmes, pruebas de rendimiento y puesta en servicio. Nuestros equipos dominan las tecnologías GPON, FTTH y los backbones de larga distancia.",
        "features": ["Despliegue FTTH (Fiber To The Home)", "Backbones interurbanos de larga distancia", "Empalme por fusión y pruebas OTDR", "Estudios de ingeniería y anteproyectos detallados", "Mantenimiento y reparación de cables dañados"],
        "useCases": ["Redes metropolitanas", "Conexión de sitios aislados", "Centros de datos y hubs de telecom", "Campus universitarios y zonas industriales"]
      },
      {
        "title": "Mantenimiento y Servicios de Telecom",
        "shortDesc": "Mantenimiento preventivo, correctivo y soporte técnico 24/7 para su infraestructura de telecomunicaciones.",
        "fullDesc": "La fiabilidad de su red depende de un mantenimiento riguroso. IS TELECOM ofrece contratos de mantenimiento a medida para su infraestructura de telecomunicaciones: intervenciones preventivas programadas, resolución correctiva rápida, soporte técnico 24/7 y gestión de repuestos.",
        "features": ["Mantenimiento preventivo con planificación personalizada", "Intervención correctiva en 4h (SLA garantizado)", "Soporte técnico NOC 24/7", "Gestión de repuestos y stocks de reserva", "Informes mensuales de rendimiento (KPI)"],
        "useCases": ["Sitios de telecom en explotación", "Centros de datos", "Estaciones base de radio", "Centros de conmutación"]
      }
    ]
  },
  "notFound": {
    "title": "Página No Encontrada",
    "description": "La página que busca no existe o ha sido movida.",
    "backHome": "Volver al Inicio"
  },
  "langSelector": {
    "fr": "Français",
    "en": "English",
    "es": "Español",
    "zh": "中文",
    "ar": "العربية"
  }
};